import React, { useEffect, useState } from 'react';
import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    TablePagination
} from '@mui/material';
import AddButton from '../../Common_Components/AddButton';
import { useNavigate } from 'react-router-dom';
import './ListUserRole.css'
import axiosInstance from '../../axios/axios';
import { hasPrivilege } from './PrevilegeCheck';
const style = {
    fontFamily: 'Times New Roman',
    fontWeight: 400,
    fontSize: '16px',
    lineHeight: '18.4px',
    color: '#000000',
    alignItems: 'center',
};


const ListuserRole = () => {
    const navigate = useNavigate()
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(25);


    const [roles, setRoles] = useState([])
    useEffect(() => {
        const getuserRoles = async () => {
            const response = await axiosInstance.get('/users/listUserRole')
            const { success, userRoles } = response.data
            if (success === true) {
                setRoles(userRoles)
            } else {
                setRoles([])
            }
        }
        getuserRoles()
    }, [])
    const handlenavigatetoAdd = async () => {
        navigate('/user/RoleAdd')
    }

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };
    return (
        <div className="role-list">
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                <h2 className='roletitle'>Roles</h2>
                {
                    hasPrivilege('Add User Role') && <div style={{ display: 'flex', alignItems: 'center' }}>
                        <AddButton onClick={handlenavigatetoAdd} />
                    </div>
                }

            </div>

            <TableContainer component={Paper}>
                <Table>
                    <TableHead style={{ backgroundColor: '#EEDEFF' }}>
                        <TableRow>
                            <TableCell sx={{ fontWeight: 700, color: '#302D2D' }}>Role Name</TableCell>
                            <TableCell sx={{ fontWeight: 700, color: '#302D2D' }}>Status</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {roles && roles.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                            .map((role, index) => (
                                <TableRow key={role.RL_ID} style={{ backgroundColor: index % 2 === 0 ? '#F6F6F6' : '#DAD9D9' }}>
                                    <TableCell sx={style}>{role.RL_Name}</TableCell>
                                    <TableCell sx={style}>{Number(role.RL_Status) === 1 ? "Active" : "Inactive"}</TableCell>

                                </TableRow>
                            ))}
                    </TableBody>
                </Table>
                <TablePagination
                    rowsPerPageOptions={[10, 25, 50]}
                    component="div"
                    count={roles.length}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                />
            </TableContainer>
        </div>
    )
}

export default ListuserRole